import { useFormik } from 'formik'
import * as Yup from 'yup'

import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import { getUserRoleFromTask } from '@shared/utils'

import Avatar from '@components/Avatar'
import SelectUser from '@components/SelectUser'

import { useAssigneeUpdate } from '../Kanban.hooks'

export default function SelectAssignee({ task, disabled = false }) {
  const updateAssignee = useAssigneeUpdate()
  const role = getUserRoleFromTask(task)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { assignee: task.assignee || null },
    validationSchema: Yup.object({ assignee: Yup.object().nullable() }),
    onSubmit: (values) => {
      if (task.assignee?.id === values.assignee?.id) return
      return updateAssignee.mutate({ taskId: task.id, userId: values.assignee?.id || null })
    },
  })

  if (disabled) {
    return (
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Avatar size="xs" user={task.assignee} hover="card" />
        <Typography>{task.assignee?.fullName}</Typography>
      </Stack>
    )
  }

  return (
    <SelectUser
      key={task.assignee?.id}
      hideBorder
      size="small"
      fullWidth
      value={formik.values.assignee}
      onChange={(user) => formik.setFieldValue('assignee', user)}
      error={formik.touched.assignee && Boolean(formik.errors.assignee)}
      helperText={formik.touched.assignee && formik.errors.assignee}
      onBlur={formik.handleSubmit}
      role={role}
      hover="card"
      sx={{ ml: -1 }}
    />
  )
}
